import { render } from "./KommendeEftersyn.vue?vue&type=template&id=86752266"
import script from "./KommendeEftersyn.vue?vue&type=script&lang=js"
export * from "./KommendeEftersyn.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__